var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 19 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.949821,-0.0324807,0.037021)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Plan-de-travail1",
    x: 0.032,
    y: -0.039,
    width: 18.865,
    height: 28.999,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Plan-de-travail11"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.05283,0.850995,0.371383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.17,1.13L2.434,1.13C1.488,1.13 0.721,1.898 0.721,2.843L0.721,21.388",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.05283,3.365,3.01821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.895,2.843C13.895,1.898 13.128,1.13 12.183,1.13L2.434,1.13C1.488,1.13 0.721,1.898 0.721,2.843L0.721,21.401C0.721,22.346 1.488,23.113 2.434,23.113L12.183,23.113C13.128,23.113 13.895,22.346 13.895,21.401L13.895,2.843Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 1
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.43b259d83abfe494a9d97c7d43c35b11.svg";
export { ForwardRef as ReactComponent };